import { render, staticRenderFns } from "./TrainingCitiesDetails.vue?vue&type=template&id=46b36da1&"
import script from "./TrainingCitiesDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingCitiesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports